/* eslint-disable jsx-a11y/anchor-is-valid */
import { Container, Typography, Box } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import styles from "./OrderDetails.module.scss";
import AppButton from "../../common/theme/Button";
import moment from "moment";
import { IMAGE_BASE_URL } from "../../constants/constants";
import { BackArrowIcon } from "../../assets/Icons/icons";
import { useNavigate, useLocation } from "react-router-dom";
const OrderDetails = ({ orderData, setOrderDetail }: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  // This would typically come from your API/state
  console.log(orderData, "orderData");
  return (
    <Container className={styles.orderDetailsContainer}>
      <Typography variant="h5" className={styles.mainTitle}>
        <a
          role="button"
          className={styles.backButton}
          onClick={() => {
            setOrderDetail(null);
            const queryParams = new URLSearchParams(location.search);

            if (queryParams.has("token")) {
              queryParams.delete("token");
              navigate({
                search: queryParams.toString(),
              });
            }
          }}
        >
          {BackArrowIcon}
        </a>{" "}
        Order Details
      </Typography>

      <Box className={styles.orderDetailsCard}>
        {/* Order Number and Date */}
        <Box className={styles.orderDetailsCardFirstSection}>
          <Box className={styles.orderHeader}>
            <Box className={styles.orderNumber}>
              <Typography variant="h6">
                Order Number : #{orderData?.customer_order_id}
              </Typography>
            </Box>
            <Box className={styles.orderDate}>
              <CalendarTodayIcon />
              <Typography color="#768F99" sx={{ fontSize: "14px" }}>
                {moment(orderData?.createdAt).format("MMMM Do, YYYY")}
              </Typography>
            </Box>
          </Box>

          {/* Contact Information */}
          <Box className={styles.contactSection}>
            <Typography variant="h6" className={styles.sectionTitle}>
              Contact Information
            </Typography>
            <Box className={styles.contactInfo}>
              <Box className={styles.contactItem}>
                <PhoneIcon />
                <Box className={styles.contactDetails}>
                  <Typography variant="body2" color="#768F99">
                    Phone Number
                  </Typography>
                  <Typography>{orderData?.phone_number}</Typography>
                </Box>
              </Box>
              <Box className={styles.contactItem}>
                <EmailIcon />
                <Box className={styles.contactDetails}>
                  <Typography variant="body2" color="#768F99">
                    Email Address
                  </Typography>
                  <Typography>{orderData?.email}</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Ordered Items */}
        <Box className={styles.orderedItemsSection}>
          <Box className={styles.orderedItemsHeader}>
            <Typography variant="h6" className={styles.sectionTitle}>
              Ordered Items ({orderData?.order_products?.length})
            </Typography>
            <Box className={styles.statusSectionWrapper}>
              {orderData?.shipstation_tracking_number && (
              <Box className={styles.statusSection}>
                <Typography variant="body2">Tracking Number :</Typography>
                <Typography
                  variant="body2"
                  style={{
                    fontWeight: "bold",
                  }}
                >
                      <a href={`https://www.ups.com/track?loc=en_US&tracknum=${orderData?.shipstation_tracking_number}`} target="_blank" rel="noreferrer">{orderData?.shipstation_tracking_number}</a>
                  </Typography>
                </Box>
              )}
              <Box className={styles.statusSection}>
                <Typography variant="body2">Fulfillment Status :</Typography>
                <Typography
                  variant="body2"
                  className={styles.statusBadge}
                  style={{
                    backgroundColor:
                      orderData?.status === 1
                        ? "#38D14B"
                        : orderData?.status === 2
                          ? "#023803"
                          : orderData?.status === 3
                            ? "#c9b60e"
                            : orderData?.status === 4
                              ? "#c9840e"
                              : "#38D14B",
                    color: "#fff",
                  }}
                >
                  {orderData?.status === 1
                    ? "RECEIVED"
                    : orderData?.status === 2
                      ? `IN PROGRESS. ${orderData.Store_detail.is_delivery_date_enabled && orderData.Store_detail.delivery_date ? `ORDER WILL SHIP BY ${moment(orderData.Store_detail.delivery_date * 1000).format("MMMM Do, YYYY")}` : ''}`
                      : orderData?.status === 3
                        ? "PENDING SHIPMENT"
                        : orderData?.status === 4
                          ? "SHIPPED"
                          : orderData?.status === 5
                            ? "DELIVERED"
                            : ""}
                </Typography>
              </Box>
              <a href={orderData?.receipt} target="_blank" download rel="noreferrer">
                <AppButton
                  type="submit"
                  style={{ cursor: "pointer" }}
                  disabled={false}
                  variant="contained"
                  color={"primary"}
              >
                Download Receipt
              </AppButton>
              </a>
            </Box>
          </Box>

          {/* Items Table */}
          <Box className={styles.itemsTable}>
            <table className={styles.table}>
              <thead>
                <tr className={styles.tableHeader}>
                  <th colSpan={2}>
                    <Typography
                      className={styles.tableHeaderItem}
                      variant="body2"
                    >
                      Product Name
                    </Typography>
                  </th>
                  <th>
                    <Typography
                      className={styles.tableHeaderItem}
                      variant="body2"
                    >
                      Product Color
                    </Typography>
                  </th>
                  <th>
                    <Typography
                      className={styles.tableHeaderItem}
                      variant="body2"
                    >
                      Product Size
                    </Typography>
                  </th>
                  <th>
                    <Typography
                      className={styles.tableHeaderItem}
                      variant="body2"
                    >
                      Quantity
                    </Typography>
                  </th>
                </tr>
              </thead>
              <tbody>
                {orderData?.order_products?.length > 0 ? (
                  orderData?.order_products?.map((item: any, index: number) => {
                    const sizeOptions = item?.order_product_options.filter(
                      (option: any) => option.product_option_type === 1
                    );
                    const colorOptions = item?.order_product_options.filter(
                      (option: any) => option.product_option_type === 2
                    );

                    return (
                      <tr
                        key={index}
                        className={`${styles.tableRow} ${index % 2 === 0 ? styles.evenRow : styles.oddRow}`}
                      >
                        <td colSpan={2}>
                          <Box className={styles.productImageContainer}>
                            <img
                              src={
                                item?.store_product?.store_product_images?.[0]
                                  ?.image
                                  ? IMAGE_BASE_URL +
                                  item?.store_product
                                    ?.store_product_images?.[0]?.image
                                  : "/images/default-product.png"
                              }
                              alt={item?.productName}
                              className={styles.productImage}
                            />
                            <Typography variant="body2">
                              {item?.store_product?.product_name}
                            </Typography>
                          </Box>
                        </td>
                        <td>
                          {colorOptions
                            ?.map((option: any) => option.product_option_value)
                            .join(", ")}
                        </td>
                        <td>
                          {sizeOptions
                            ?.map((option: any) => option.product_option_value)
                            .join(", ")}
                        </td>
                        <td>{item?.quantity}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={5}>
                      <Typography variant="body2" className={styles.noData}>
                        No data found
                      </Typography>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default OrderDetails;
